module.exports = __webpack_public_path__ + "static/media/Clock.73709786.svg";